import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function MainStats() {
  const { t } = useTranslation();
  const [titleRef, titleVisible] = useScrollAnimation();
  const [textRef, textVisible] = useScrollAnimation();
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();

  return (
    <div className="mainstats-wrapper">
      <div className="mainstats container">
        <div 
          ref={titleRef}
          className={`mainstats-title flex ${titleVisible ? "animate-in" : ""}`}
        >
          <div className="circle"></div>
          <h4 className="clr-green fs-700">{t("mainStats.ourExpertise")}</h4>
        </div>
        <div 
          ref={textRef}
          className={`mainstats-text ${textVisible ? "animate-in" : ""}`}
        >
          <h2 className="fs-800">
            {t("mainStats.title")}
          </h2>
          <p className="fs-500">
            {t("mainStats.description")}
          </p>
        </div>
        <div className="mainstats-grid flex">
          <div 
            ref={card1Ref}
            className={`mainstats-card clr-white flex ${card1Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/iso.svg" alt="ISO 9001" />
            <h3 className="uppercase fs-700">{t("mainStats.iso9001")}</h3>
            <p className="fs-400">
              {t("mainStats.iso9001Desc")}
            </p>
          </div>
          <div 
            ref={card2Ref}
            className={`mainstats-card flex clr-white ${card2Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/osha.svg" alt="OSHA Safety" />
            <h3 className="uppercase fs-700">{t("mainStats.oshaSafety")}</h3>
            <p className="fs-400">
              {t("mainStats.oshaSafetyDesc")}
            </p>
          </div>
          <div 
            ref={card3Ref}
            className={`mainstats-card flex clr-white ${card3Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/isoo.svg" alt="ISO 14001" />
            <h3 className="uppercase fs-700">{t("mainStats.iso14001")}</h3>
            <p className="fs-400">
              {t("mainStats.iso14001Desc")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainStats;
